import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./components/App/App";
import "./i18n/i18n";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <Suspense fallback="Loading">
    <App />
  </Suspense>,
  document.getElementById("root")
);

serviceWorker.register();
